import { flattenDeep } from 'lodash';

/**
 * Searches through all the items in the array for the provided value.
 * The values to be searched against are those returned by the
 * `extractor` parameter. By default, the plain items are searched
 * against.
 *
 * The search is performed on a flattened version of the array, containing
 * all the values as returned by the extractor function. Only values of
 * type `string` or `number` are considered. Also, both the array values
 * and the filter's string are set to lowercase. Passing an empty filter
 * value will return the original array.
 *
 * @param array
 * @param filterValue
 * @param extractor a function to extract the values to be searched
 *                  against from each item in the original array
 */
export const filterDeep = <T>(array: T[], filterValue: string, extractor?: (item: T) => any[]): T[] => {
    if (filterValue) {
        // By default peek into all of the item's properties
        if (extractor === null || extractor === undefined) {
            extractor = item => (<Array<keyof T>>Object.keys(item)).map(key => item[key]);
        }

        array = array.filter(item => {
            const values: T[] = flattenDeep(extractor!(item))
                .filter(value => typeof value === 'string' || typeof value === 'number')
                .map(value => value.toString().toLowerCase());

            return values.some((value: any) => value.includes(filterValue.toLowerCase()));
        });
    }

    return array;
}
